import { Messages } from '../../../../codegen/Localize';
import { ISubscriptionInfo } from '../../../../ts/models/ISubscriptionInfo';
import { changeSubscriptionSubject } from '../../../actions/spaces/SubscriptionsActions';
import { IEntityAction } from './IEntityAction';

export const ChangeSubscriptionSubjectEntityAction: IEntityAction<ISubscriptionInfo, {}> = {
  name: 'tasks-change-subject',
  translateName: Messages.changeSubject_action,
  isVisible: () => true,
  isClickable: (availableActions: {}, subscriptions: ISubscriptionInfo[]) => {

    if(subscriptions.length > 1) { // We do not allow action for multiple items
      return false;
    }

    return subscriptions[0].canManageSubscription;
  },
  createReduxAction: (subscriptions: ISubscriptionInfo[]) => changeSubscriptionSubject(subscriptions[0])
};
